import { OneEducationCoreModule } from '@oneeducation/app-core';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ManageBasesComponent, ViewUsersComponent } from './components';

@NgModule({
  declarations: [ManageBasesComponent, ViewUsersComponent],
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    ConfirmDialogModule,
    CheckboxModule,
    SelectModule,
    ToggleButtonModule,
    InputTextModule,
    ButtonModule,
    DynamicDialogModule,
    OneEducationCoreModule
  ],
  providers: [ConfirmationService, DatePipe],
  exports: [ManageBasesComponent, ViewUsersComponent]
})
export class SchoolManagementModule {}
